module.exports = __webpack_public_path__ + "img/salty-5.7c5fc5c7.webp";